/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import DataVaxiomProfessionalView from 'DesignSystem/DataVaxiomProfessionalView/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Professionals/AddAction/Search/Content/Profiles/Content/ViewProfessional/Content"
  
}) {
  return (<React.Fragment
>
<DataVaxiomProfessionalView
  viewPath={`${viewPath}/DataVaxiomProfessionalView`}
/>
{children}
</React.Fragment>)
}